import {Dispatch, SetStateAction} from 'react'

export type Permission = 'list_user' | 'new_user' | 'new_user_admin' | 'edit_user' | 'delete_user'

export type UserRole = 'admin' | 'operative' | 'authorizer'

export type UserStatus = 'active' | 'blocked' | 'deleted'

export interface User {
  id: string
  enterpriseId: string
  name: string
  username: string
  emailAddress: string
  contactPhoneNumber: string
  createdBy?: string
  creationDate: string
  formattedCreationDate: string
  modificationDate: string
  formattedModificationDate: string
  type: UserRole
  formattedType: string
  status: UserStatus
  formattedStatus: string
}

export interface UserFiltersType {
  page: number
  pageSize: number
  timestamp?: string
  search: string
}

export const permissionRoles = new Map<Permission, User['type'][]>([
  ['list_user', ['admin', 'authorizer']],
  ['new_user', ['admin', 'authorizer']],
  ['new_user_admin', ['admin']],
  ['edit_user', ['admin', 'authorizer']],
  ['delete_user', ['admin', 'authorizer']],
])

export type ListViewContextProps = {
  userIdForUpdate?: string | undefined
  setUserIdForUpdate: Dispatch<SetStateAction<string | undefined>>
  userIdForDelete?: string | undefined
  setUserIdForDelete: Dispatch<SetStateAction<string | undefined>>
}

export const initialListView: ListViewContextProps = {
  userIdForDelete: undefined,
  userIdForUpdate: undefined,
  setUserIdForUpdate: () => {},
  setUserIdForDelete: () => {},
}
